import { ToolbarPositions } from '@/components/draggableToolbar/DraggableToolbar.types';
import useReadLocalStorage from './useReadLocalStorage';

export const useToolbarPosition = () =>
  useReadLocalStorage(
    'contensis-blocks-preview-toolbar-position'
  ) as keyof typeof ToolbarPositions;
